
ADILF.define('streamhub-sdk/auth/auth-optional',['require','exports','module'],function (require, exports, module) {/**
 * auth-optional
 * A stub of `auth` that will work as if
 * no delegate is registered and no user
 * is logged in.
 */
module.exports = {
    get: function () {},
    login: function () {},
    logout: function () {},
    hasDelegate: function () {},
    on: function () {},
    isAuthenticated: function () {}
};

});
